module.exports = __webpack_public_path__ + "img/analytics.e46828a8.svg";